import {
  Newspaper,
  ClipboardList,
  ThumbsUp,
  CalendarHeart,
  Video,
  Target,
  ShoppingCart,
  TrendingUp,
  MapPin,
} from 'lucide-react';
import HubPage from '../components/ui/HubPage';

// Hub Gestión (PR-UX2): contenido, evaluación, suscripciones, pedidos y
// analítica. Comunicaciones salió del hub a item de primer nivel del sidebar.
// Las páginas destino siguen montadas en sus rutas; aquí solo se enlazan como
// tarjetas. Analítica es a su vez un sub-hub (Contabilidad + Estadísticas).

export default function GestionPage() {
  return (
    <HubPage
      subtitle="Contenido, evaluaciones, suscripciones, pedidos y analítica del club."
      cards={[
        {
          to: '/noticias',
          icon: Newspaper,
          title: 'Noticias',
          description: 'Muro de noticias del club.',
          testid: 'hub-card-noticias',
        },
        {
          to: '/evaluaciones',
          icon: ClipboardList,
          title: 'Evaluaciones',
          description: 'Evaluaciones mensuales de los alumnos.',
          testid: 'hub-card-evaluaciones',
        },
        {
          to: '/valoraciones',
          icon: ThumbsUp,
          title: 'Valoraciones',
          description: 'Valoraciones de las sesiones por los alumnos.',
          testid: 'hub-card-valoraciones',
        },
        {
          to: '/suscripciones',
          icon: CalendarHeart,
          title: 'Suscripciones',
          description: 'Productos de suscripción mensual y su gestión.',
          testid: 'hub-card-suscripciones',
        },
        {
          to: '/video-analisis',
          icon: Video,
          title: 'Análisis de vídeo',
          description: 'Servicio de análisis de vídeo y entregas.',
          testid: 'hub-card-video-analisis',
        },
        {
          to: '/tecnificacion-individual',
          icon: Target,
          title: 'Tecnificación individual',
          description: 'Solicitudes 1-a-1: crear la serie de 4 sesiones.',
          testid: 'hub-card-tecnificacion-individual',
        },
        {
          to: '/pedidos',
          icon: ShoppingCart,
          title: 'Pedidos',
          description: 'Pedidos de tienda y su estado de envío.',
          testid: 'hub-card-pedidos',
        },
        {
          to: '/analitica',
          icon: TrendingUp,
          title: 'Analítica',
          description: 'Contabilidad y estadísticas del negocio.',
          testid: 'hub-card-analitica',
        },
        {
          to: '/sedes',
          icon: MapPin,
          title: 'Sedes',
          description: 'Instalaciones donde se imparten las sesiones.',
          testid: 'hub-card-sedes',
        },
      ]}
    />
  );
}
